export function CmsSettings() {
  return (
    <div className="space-y-4">
      <h1 className="text-2xl font-bold text-text">CMS Settings</h1>
      <p className="text-text-muted">CMS configuration and settings will be implemented here.</p>
    </div>
  )
}
